module.exports = __webpack_public_path__ + "static/media/tile-select.22cf8c71.mp3";